import { API } from '../Api';

// Lý do (khớp enum ReportPostValue của BE)
export const ACCOUNT_REPORT_REASONS: { value: number; label: string }[] = [
  { value: 6, label: 'Lừa đảo / spam' },
  { value: 4, label: 'Quấy rối / công kích' },
  { value: 2, label: 'Ngôn từ thù ghét (toxic)' },
  { value: 1, label: 'Nội dung không phù hợp' },
  { value: 9, label: 'Nội dung nhạy cảm / khiêu dâm' },
  { value: 8, label: 'Nguy hại trẻ em' },
  { value: 7, label: 'Mạo danh / thông tin sai lệch' },
  { value: 10, label: 'Khác' },
];

export const reportAccount = (payload: {
  targetUserId: string;
  reason: number;
  content?: string;
}) => {
  // Gateway route ReportController "lách" version: {version}=report → /api/report/...
  return API.post<boolean>('/report/user-service/report-account', {
    targetUserId: payload.targetUserId,
    reason: payload.reason,
    content: payload.content ?? '',
  }).then((res) => res.data);
};

// ----- Admin -----
export interface AccountReport {
  id: string;
  targetUserId: string;
  targetUserName?: string;
  reportByUserId: string;
  reportByUserName?: string;
  reason: number;
  content?: string;
  stateReport: number; // 0 Pending, 1 Accepted, 2 Rejected
  createdAt: string;
}

export const getAccountReports = (
  state?: number,
  pageNumber = 1,
  pageSize = 20
) => {
  const params: Record<string, number> = { pageNumber, pageSize };
  if (state !== undefined) params.state = state;
  return API.get<AccountReport[]>('/v1/user-service/admin/ReportAccount/list', {
    params,
  }).then((res) => res.data ?? []);
};

export const handleAccountReport = (reportId: string, accept: boolean) => {
  return API.post<boolean>('/v1/user-service/admin/ReportAccount/handle', {
    reportId,
    accept,
  }).then((res) => res.data);
};
